<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Document</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Maintain Legal & Help Documents For Staging and App
    </ion-list-header>

    <ion-list lines="none">
        <ion-radio-group value="staging" class="ion-no-padding" [(ngModel)]="document.domain"
            (ionChange)="onToggleDomainChange($event)">
            <ion-item>
                <ion-label class="ion-text-wrap ion-no-padding">
                    <span class="line1">Staging Document.</span><br />
                </ion-label>
                <ion-radio slot="start" value="staging"></ion-radio>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap ion-no-padding">
                    <span class="line1">App Document.</span><br />
                </ion-label>
                <ion-radio slot="start" value="app"></ion-radio>
            </ion-item>
        </ion-radio-group>


        <ion-item data-test="documentItem" id="document" (click)="onDocumentClick()">
            <ion-label class="ion-text-wrap" position="stacked">Document Name</ion-label>
            <ion-input data-test="documentName" id="role" type="text" [(ngModel)]="document.documentName"
                placeholder="Click to set the document name" readonly></ion-input>
        </ion-item>

        <ion-item>
            <ion-label position="stacked">View Name</ion-label>
            <ion-input type="text" [(ngModel)]="document.viewName" data-test="viewName" readonly></ion-input>
        </ion-item>

        <ion-item>
            <ion-label position="stacked">Uid</ion-label>
            <ion-input type="text" readonly [(ngModel)]="document.uid" data-test="uid"></ion-input>
        </ion-item>

        <ion-item>
            <ion-label class="ion-text-wrap" position="stacked">Contents</ion-label>
            <ion-textarea rows="9" [(ngModel)]="document.contents" data-test="contents"></ion-textarea>
        </ion-item>

        <ion-item>
            <ion-buttons slot="end">
                <ion-button color="secondary" fill="solid" size="small" expand="block" data-test="loadDefaultTemplate"
                    (click)="onLoadDefaultTemplateClick()">
                    Load Default Template
                </ion-button>
            </ion-buttons>
        </ion-item>

    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick()" data-test="save">Save</ion-button>
    </ion-toolbar>
</ion-footer>